import { getApps, initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth'

import env from '../config/env'

const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true'
const emulatorUrl = import.meta.env.VITE_FIREBASE_EMULATOR_URL || 'http://localhost:9099'
const firebaseConfig = {
  ...env.FIREBASE,
  projectId: (useEmulator && import.meta.env.VITE_FIREBASE_PROJECT_ID) || env.FIREBASE.projectId,
}

let firebaseAuth
if (getApps().length < 1) {
  const firebaseApp = initializeApp(firebaseConfig)
  firebaseAuth = getAuth(firebaseApp)
  setPersistence(firebaseAuth, browserLocalPersistence)
  if (useEmulator) {
    connectAuthEmulator(firebaseAuth, emulatorUrl)
  }
}

export default {
  auth: firebaseAuth,
}
